var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-forward"},[_c('button',{class:['btn', 'btn-' + _vm.color],style:(_vm.buttonStyle),attrs:{"type":"button"}},[_c('div',{staticClass:"d-flex flex-row"},[_vm._v(" "+_vm._s(_vm.labelName)+"   "),_c('IconCaretRight',{attrs:{"width":"15px","height":"15px"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }